module.exports = "/images/side-site-monitoring-active.svg?f78e1cdc675d006a723f6866a8865879";